module.exports = __webpack_public_path__ + "02_glasses_red.ee0ddc91.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer4/02_glasses_red.png
// module id = D1/M
// module chunks = 0